import { render, staticRenderFns } from "./taskHistory.vue?vue&type=template&id=784ebfca&scoped=true&"
import script from "./taskHistory.vue?vue&type=script&lang=js&"
export * from "./taskHistory.vue?vue&type=script&lang=js&"
import style0 from "./taskHistory.vue?vue&type=style&index=0&id=784ebfca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ebfca",
  null
  
)

component.options.__file = "taskHistory.vue"
export default component.exports